import { Route } from "vue-router";

export const routerBeforeResolve = async (
  toRoute: Route,
  fromRoute: Route,
  next: (...args: any[]) => void
): Promise<void> => {
  try {
    for (const route of toRoute.matched) {
      const beforeResolve = route.meta?.beforeResolve;

      if (typeof beforeResolve === "function") {
        const shouldRedirect = await new Promise<boolean>((resolve, reject) => {
          beforeResolve(toRoute, fromRoute, (...args: any[]) => {
            if (args.length > 0) {
              if (fromRoute.name === args[0]?.name) {
                // Optional: log if needed.
              }
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve(false); // Continue to next route
            }
          });
        });
        if (shouldRedirect) break;
      }
    }

    next();
  } catch (error) {
    // Redirection happened, no further action.
  }
};
